module.exports = __webpack_public_path__ + "img/structure@2x.3557708c.png";